var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 531 556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1_surat-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #0088ce } \n\t\t.s1 { fill: #29abe2 } \n\t\t.s2 { fill: #35caed } \n\t\t.s3 { fill: #7dc3e8 } \n\t\t.s4 { mix-blend-mode: screen;fill: #7dc3e8 } \n\t\t.s5 { fill: #00659c } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m265.5 6.9l256 182.9l-256 240l-255.9-240z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m265.5 6.9l256 182.9l-256 193l-255.9-193z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m521.5 189.8l-20.6 15.5l-235.4-168.2l-235.3 168.2l-20.6-15.5l255.9-182.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m521.5 192.7v353.9l-185.5-175.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m521.5 192.7v353.9l-150.8-178.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m265.5 429.8l65.5-61.5l188.2 178.3h-509.6l187.7-174.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m12.2 196.1l185.1 175.8l-187.7 174.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m159.7 368.3l-150.8 178.3v-353.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m197.3 374.7l68.2 55.1l65.5-61.5l188.2 180.8l-188.6-151.6l-66.2 58l-65.3-61l-180.3 149.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m64.8 64.9q404.9-2 404.9 0q0 2 0 174.4l-204.2 190.5l-206.4-193.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m466.9 75.2l-377.4 13.2v140.4l174.9 197.8l-202.9-188.9v-173.7l405.4 0.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m349.2 72.9h-167.4c-3 0-5.6-1.9-6.5-4.7c-0.9-2.9 0.1-5.9 2.5-7.6l83.7-59.3c2.4-1.6 5.5-1.6 7.9 0l83.7 59.3c2.4 1.7 3.4 4.7 2.5 7.6c-0.9 2.8-3.5 4.7-6.4 4.7zm-146.1-13.6h124.7l-62.3-44.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m7.8 555.9q-1.4 0-2.7-0.6c-2.5-1-4.1-3.5-4.1-6.2v-358.8c0-2.7 1.6-5.1 4.1-6.2c2.5-1.1 5.3-0.6 7.3 1.3l190.5 179.3c1.4 1.3 2.1 3.1 2.1 4.9c0 1.9-0.7 3.7-2.1 5l-190.5 179.5c-1.3 1.2-2.9 1.8-4.6 1.8zm6.7-349.9v327.4l173.9-163.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m61.4 247.6c-1.7 0-3.4-0.7-4.7-1.9l-53.6-50.5c-1.3-1.2-2.1-3-2.1-4.9v-1c0-2.2 1-4.3 2.8-5.6l53.7-37.9c2-1.5 4.7-1.7 7-0.5c2.2 1.2 3.6 3.5 3.6 6v89.5c0 2.7-1.6 5.1-4 6.2q-1.4 0.6-2.7 0.6zm-43.6-57.1l36.8 34.6v-60.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m7.8 197.1c-1.8 0-3.5-0.7-4.8-2l-0.6-0.6c-2.6-2.6-2.6-6.9 0-9.5c2.7-2.7 7-2.7 9.6 0l0.6 0.5c2.6 2.7 2.6 7-0.1 9.6c-1.3 1.3-3 2-4.7 2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m469.6 246.5c-1.8 0-3.6-0.7-4.9-2.1c-2.6-2.7-2.4-7 0.3-9.6l53.1-50c2.7-2.5 7-2.4 9.6 0.3c2.5 2.7 2.4 7-0.3 9.6l-53.1 50c-1.3 1.2-3 1.8-4.7 1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m331.3 376.8c-1.5 0-3-0.5-4.3-1.6l-0.4-0.3c-2.9-2.4-3.3-6.7-0.9-9.6c2.4-2.9 6.7-3.3 9.6-0.9l0.4 0.4c2.9 2.4 3.3 6.6 0.9 9.5c-1.4 1.6-3.3 2.5-5.3 2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m523.2 555.9h-515.4c-2.8 0-5.3-1.7-6.3-4.3c-1.1-2.6-0.4-5.5 1.6-7.4l190.5-179.5c2.6-2.4 6.7-2.4 9.3 0l62.1 58.5l61.7-58.1c2.6-2.5 6.7-2.5 9.3-0.1l84 78.5l107.9 100.7c2 1.9 2.7 4.8 1.6 7.4c-1 2.6-3.5 4.3-6.3 4.3zm-498.4-13.6h481.2l-174.6-163l-61.8 58.2c-2.6 2.4-6.7 2.4-9.3 0l-62-58.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m523.2 555.9c-1.7 0-3.3-0.6-4.6-1.8l-107.8-100.7l-84.1-78.5c-1.4-1.2-2.1-3-2.1-4.9c0-1.9 0.7-3.7 2.1-5l2.2-2l133.9-126.2v-85.5c0-2.5 1.5-4.8 3.7-6c2.3-1.1 5-1 7 0.5l53.6 37.9c1.8 1.3 2.9 3.4 2.9 5.6v359.8c0 2.7-1.6 5.2-4.1 6.2q-1.3 0.6-2.7 0.6zm-181.9-185.9l175.2 163.5v-340.7l-40.1-28.4v75.4c0 1.8-0.8 3.6-2.1 4.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m265 439.3c-1.7 0-3.4-0.6-4.7-1.8l-66.7-62.9l-136.9-128.9c-1.3-1.2-2.1-3-2.1-4.9v-174.7c0-3.7 3-6.8 6.8-6.8h408.2c3.8 0 6.8 3.1 6.8 6.8v173.7c0 1.8-0.8 3.6-2.1 4.9l-204.7 192.8c-1.3 1.2-3 1.8-4.6 1.8zm-196.9-201.4l134.8 126.8l62.1 58.5l197.8-186.4v-163.9h-394.7z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon2);
export default __webpack_public_path__ + "static/media/saveIcon2.bdb9d120ea868ac821ce7b71167903c4.svg";
export { ForwardRef as ReactComponent };